<nav class="navbar navbar-expand-lg navbar-light bg-transparent">
  <div class="container-fluid">
    <!-- Logo -->
    <a class="navbar-brand custom-brand">
      <div class="logo-container" *ngIf="globals.hostnameStr === 'mineolaluxuryrealestate.com' || globals.hostnameStr === 'oakvillesluxuryrealestate.com'">
        <div class="agent-wrapper">
          <img *ngIf="globals.hostnameStr === 'mineolaluxuryrealestate.com'"
               src="https://cndrep.s3.us-west-2.amazonaws.com/cm-mobile/img/natalie.png"
               alt="Natalie Costello"
               class="agent-logo">
          <img *ngIf="globals.hostnameStr === 'oakvillesluxuryrealestate.com'"
               src="https://cndrep.s3.us-west-2.amazonaws.com/cm-mobile/img/donna.png"
               alt="Donna Gray"
               class="agent-logo">
        </div>
        <div class="main-wrapper">
          <img src="https://cndrep.s3.us-west-2.amazonaws.com/cm-mobile/img/CM-WebLogo.png"
               alt="Cayman Marshall International"
               class="main-logo">
        </div>
      </div>

      <a href="https://{{globals.hostnameStr}}" target="_blank"><img *ngIf="globals.hostnameStr !== 'mineolaluxuryrealestate.com' && globals.hostnameStr !== 'oakvillesluxuryrealestate.com'"
                                                                     src="https://dhauv7lm2gh1r.cloudfront.net/cm-mobile/img/logo-main.png"
                                                                     alt="Cayman Marshall International"
                                                                     class="resize-logo"></a>
    </a>


    <!-- Mobile Toggle Button -->
    <button
      class="navbar-toggler"
      type="button"
      (click)="toggleCollapse()"
      [attr.aria-expanded]="!isCollapsed"
      aria-controls="navbarSupportedContent"
      aria-label="Toggle navigation"
      [style.display]="isPeelHaltonSite ? 'none' : 'block'"
      style="margin-bottom: 10px;">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Navbar Links -->
    <div
      class="collapse navbar-collapse justify-content-end"
      id="navbarSupportedContent"
      [ngbCollapse]="isCollapsed" *ngIf="globals.linksEnabledBln">
      <ul class="navbar-nav">
        <li *ngFor="let item of menuItems; let i = index"
            class="nav-item"
            [ngClass]="{'dropdown': item.subItems.length > 0, 'active': isActive(item)}"
            ngbDropdown
            [open]="dropdownOpen === i"
            (mouseenter)="openDropdown(i)"
            (mouseleave)="closeDropdown()">

          <a class="nav-link dropdown-toggle"
             href="javascript:void(0);"
             ngbDropdownToggle
             [ngClass]="{'active': isActive(item)}"
             (click)="navigateToLink(item.link, $event); $event.preventDefault()"
             (keydown)="navigateToLink(item.link, $event)"
             role="menuitem"
             tabindex="0"
          >
            {{ item.name }}
          </a>

          <!-- Only show dropdown if the item has subItems -->
          <ul *ngIf="item.subItems.length > 0" class="dropdown-menu">
            <li *ngFor="let subItem of item.subItems">
              <a class="dropdown-item"
                 [attr.href]="subItem.link"
                 (click)="navigateToLink(subItem.link, $event); $event.preventDefault()"
                 (keydown)="navigateToLink(subItem.link, $event)"
                 [routerLinkActive]="'active'"
                 role="menuitem"
                 tabindex="0">{{ subItem.name }}</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>
